import "./index.css"

import { jsx } from 'react/jsx-runtime';
import { Image } from '@design-system/image';

const ExtendableImage = ({ props, element, className, }) => {
    if (element)
        return element;
    if (props)
        return jsx(Image, Object.assign({ className: className }, props));
    return null;
};

export { ExtendableImage };
